/* eslint-disable max-statements */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import { ActivityObject } from '../../params/redux/activity';
import AutomationApi from '../../apis/automation';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import { fetchAutomationActivityThunk } from '../../redux/thunks/activity';
import { fetchClientsCustomerThunk } from '../../redux/thunks/customer';
import { fetchFormsThunk } from '../../redux/thunks/form';
import LabelWrapper from '../wrapper/label';
import PipelineApi from '../../apis/pipeline';
import { replaceToken } from '../../redux/slices/index';
import { settingSelectedPipeline } from '../../redux/slices/pipeline';
import { showError } from '../../redux/slices/error';
import { styled } from '@mui/material/styles';
import { UpdateAutomationParams } from '../../params/redux/automation';
import { updateAutomationThunk } from '../../redux/thunks/automation';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, IconButton, Popover, SelectChangeEvent, Switch, Tooltip, Typography } from '@mui/material';
import { brand, green, orange, red } from '../../theme/themePrimitives';
import { Close, InfoOutlined } from '@mui/icons-material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { fieldsOptions, formatDateWithTime } from '../../helper';
import { PipelineObject, StageObject } from '../../params/redux/pipeline';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const IOSSwitch = styled(Switch)(({ theme }) => ({
    'width': 42,
    'height': 26,
    'padding': 0,
    '& .MuiSwitch-switchBase': {
        'padding': 0,
        'margin': 2,
        'transitionDuration': '300ms',
        '&.Mui-checked': {
            'transform': 'translateX(16px)',
            'color': '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: brand[300],
                opacity: 1,
                border: 0
            }
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));

interface WorkFlowLogOject {
    id: number;
    deal: string;
    contact: string;
    date: string;
    status: string;
}

interface PipelineResponse extends Record<string, unknown> {
    success: 0 | 1;
    token: string;
    pipeline: PipelineObject
}

const AutomationSettingsComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { token } = useSelector((state: RootState) => state.app);
    // const [selectedNames, setSelectedNames] = useState<{ label: string, value: number }[]>([]);
    const { selectedAutomation, loaders } = useSelector((state: RootState) => state.automation);
    const { pipelines, selectedPipeline } = useSelector((state: RootState) => state.pipeline);
    const { activities, loaders: activityLoaders } = useSelector((state: RootState) => state.activity);
    const { forms } = useSelector((state: RootState) => state.form);
    // const { customers } = useSelector((state: RootState) => state.customer);
    const [selectedPipelineId, setSelectedPipelineId] = useState<number | null>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedStageId, setSelectedStageId] = useState<number | null>(null);
    const [emailSubject, setEmailSubject] = useState<string>('');
    const [automationName, setAutomationName] = useState<string>('');
    // [].map(() => ({})) ||
    const rows: WorkFlowLogOject[] = activities.map((activity: ActivityObject, index: number) => ({
        id: index + 1,
        deal: activity.title || '',
        contact: activity.contact || '',
        date: formatDateWithTime(activity.created_at),
        status: activity.status as string
        })) || [];

    useEffect(() => {
        const fetchPipelineStages = async () => {
            try {
                const response: PipelineResponse = await PipelineApi.getSinglePipelineDetail(token, selectedAutomation?.pipeline_id || 0) as PipelineResponse;
                if (response.success) {
                    dispatch(replaceToken(response.token));
                    dispatch(settingSelectedPipeline(response?.pipeline));
                    setSelectedPipelineId(response?.pipeline?.id || 0);
                    setSelectedStageId(selectedAutomation?.stage_id || null);
                    // onValueChangeHandler('pipeline_id', pipelineId);
                } else {
                    dispatch(showError({
                        title: 'Error',
                        description: response.msg
                    }));
                }
            } catch (e) {
                //
            }
        };
        if (selectedAutomation) {
            if (selectedAutomation.pipeline_id) {
                fetchPipelineStages();
            }
            setEmailSubject(selectedAutomation.email_subject === 'Empty Subject' || !selectedAutomation.email_subject ? '' : selectedAutomation.email_subject);
            setAutomationName(selectedAutomation.automation_name || '');
        }
    }, [selectedAutomation]);

    useEffect(() => {
        const fetchAllPipelines = async () => {
            try {
                await dispatch(fetchAutomationActivityThunk()).unwrap();
                if (location.pathname.includes('/app/client/') && id) {
                    await dispatch(fetchFormsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                    await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                }
            } catch (e) {
                // Catch errors
            }
        };
        fetchAllPipelines();
    }, [dispatch, id]);

    const columns: GridColDef<WorkFlowLogOject>[] = [
        {
            field: 'deal',
            headerName: 'DEAL (COMPANY)',
            flex: 1
        },
        { field: 'contact', headerName: 'CONTACT', flex: 1 },
        { field: 'date', headerName: 'DATE & TIME', flex: 1 },
        { field: 'status', headerName: 'STATUS', flex: 1, renderCell: (params: GridRenderCellParams<WorkFlowLogOject, string>) => <Box marginY="14px" bgcolor={params.value === 'Sent' ? green[100] : red[100]} color={params.value === 'Sent' ? green[300] : red[300]} display="flex" alignItems="center" width="max-content" borderRadius={1} px={2} paddingY="2px"><Typography variant="body1" fontWeight="bold">{params.value?.toLocaleUpperCase()}</Typography></Box> }
    ];
    const onValueChangeHandler = async (key: keyof UpdateAutomationParams, value: 0 | 1 | string | 'active' | 'inactive' | number) => {
        try {
            const data: UpdateAutomationParams = {
                automation_id: selectedAutomation?.id || 0,
                automation_name: selectedAutomation?.automation_name || '',
                email_thread: selectedAutomation?.email_thread || 0,
                email_subject: selectedAutomation?.email_subject || '',
                pipeline_id: key === 'stage_id' ? selectedPipelineId || 0 : selectedAutomation?.pipeline_id || 0,
                stage_id: selectedAutomation?.stage_id || 0,
                form_id: selectedAutomation?.form_id || 0,
                status: selectedAutomation?.status || 'inactive',
                [key]: value
            };
            await dispatch(updateAutomationThunk({ data, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
        } catch (e) {
            //
        }
    };

    const handlePipelineChange = async (event: SelectChangeEvent<unknown>) => {
        event.preventDefault();
        const target = event.target as HTMLInputElement;
        const pipelineId = parseInt(target.value as string, 10);
        try {
            const response: PipelineResponse = await PipelineApi.getSinglePipelineDetail(token, pipelineId) as PipelineResponse;
            if (response.success) {
                dispatch(replaceToken(response.token));
                dispatch(settingSelectedPipeline(response?.pipeline));
                setSelectedPipelineId(response?.pipeline?.id || 0);
                setSelectedStageId(null);
                // onValueChangeHandler('pipeline_id', pipelineId);
            } else {
                dispatch(showError({
                    title: 'Error',
                    description: response.msg
                }));
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleStageChange = async (event: SelectChangeEvent<unknown>) => {
        const stageId = Number(event.target.value);
        try {
            const response = await AutomationApi.checkPipeline(token, selectedPipelineId || 0, stageId);
            if (response.success) {
                if (selectedPipelineId) {
                    onValueChangeHandler('stage_id', stageId);
                    setSelectedStageId(stageId);
                }
            } else {
                setSelectedPipelineId(null);
                dispatch(showError({
                    title: 'Error',
                    description: response.msg
                }));
            }
        } catch (e) {
            //
        }
    };

    const handleInfoClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const popoverId = open ? 'info-popover' : '';

    return <Box width="100%">
        <Typography variant="h5" align="center" color="textSecondary" gutterBottom>Manage Automation Settings</Typography>
        <Box display="flex" alignItems="center">
            <Typography variant="body1" color="textDisabled" minWidth="20%">Automation name</Typography>
            <CustomInput
                value={automationName}
                onChange={(e) => setAutomationName(e.target.value)}
                placeholder="Enter automation name"
                onBlur={() => onValueChangeHandler('automation_name', automationName)}
            />
        </Box>
        <Box display="flex" alignItems="center" my={2}>
            <Box display="flex" alignItems="center" gap={1} minWidth="20%">
                <Typography variant="body1" color="textDisabled">Send all email in threads</Typography>
                <IconButton color="secondary" onClick={handleInfoClick}>
                    <InfoOutlined fontSize="small" sx={{ cursor: 'pointer' }} />
                </IconButton>
                <Popover
                    id={popoverId}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                >
                    <Box p={2} maxWidth="250px">
                        <Typography variant="body2">
                            Be sure to add time delays between emails to ensure the thread functions properly.
                        </Typography>
                    </Box>
                </Popover>
            </Box>
            <Box display="flex" alignItems="center" gap={1} marginRight={2}>
                <IOSSwitch
                    checked={selectedAutomation?.email_thread === 1}
                    onChange={() => onValueChangeHandler('email_thread', selectedAutomation?.email_thread === 1 ? 0 : 1)}
                />
                <CustomInput
                    value={emailSubject}
                    onChange={(e) => setEmailSubject(e.target.value)}
                    placeholder="Type email subject here"
                    disabled={selectedAutomation?.email_thread !== 1}
                    onBlur={() => onValueChangeHandler('email_subject', emailSubject)}
                />
            </Box>
            <Box>
                <CustomDropdown
                    options={fieldsOptions}
                    value=""
                    onChange={(e) => onValueChangeHandler('email_subject', `${emailSubject} [${e.target.value}]`)}
                    placeholder="Add Field"
                    disabled={selectedAutomation?.email_thread !== 1}
                    sx={{
                        marginBottom: '0'
                    }}
                /></Box>
        </Box>
        <Box display="flex" alignItems="center">
            <Typography variant="body1" color="textDisabled" minWidth="20%">
                Stage Trigger
                <Tooltip title="The pipeline and stage trigger determines when the automation will begin. When a deal reaches this specific stage, the associated automation actions will automatically execute." arrow>
                    <IconButton color="secondary">
                        <InfoOutlined fontSize="small" sx={{ cursor: 'pointer' }} />
                    </IconButton>
                </Tooltip>
            </Typography>
            <Box display="flex" gap="20px" width="100%" boxSizing="border-box">
                <Box boxSizing="border-box">
                    {pipelines.length !== 0 && <CustomDropdown
                        options={pipelines.map((pipe) => ({
                            label: pipe.name,
                            value: pipe.id
                        }))}
                        onChange={handlePipelineChange}
                        placeholder="Select Pipeline"
                        error={false}
                        value={selectedPipelineId}
                        disabled={loaders.isUpdating}
                    />}
                </Box>
                <Box boxSizing="border-box">
                    <Box boxSizing="border-box">{
                        <CustomDropdown
                            options={
                                selectedPipeline?.pipeline_stages
                                    ? selectedPipeline.pipeline_stages.map((pipe: StageObject) => ({
                                        label: pipe.stage_name,
                                        value: pipe.id
                                    }))
                                    : []
                            }
                            onChange={handleStageChange}
                            error={false}
                            value={selectedStageId}
                            placeholder="Select Stage"
                            disabled={loaders.isUpdating || pipelines.length === 0 || !selectedPipelineId}
                        />
                    }</Box>
                </Box>
            </Box>
        </Box>
        {location.pathname.includes('/app/client/') && <Box my={2}>
            <Box display="flex" alignItems="center">
            <Typography variant="body1" color="textDisabled" minWidth="20%">Assign forms to automation</Typography>
            <Box display="flex" gap="20px" width="100%" boxSizing="border-box">
                <Box boxSizing="border-box">
                    <CustomDropdown
                        options={forms.filter((item) => item.type !== 'custom').map((form) => ({
                            label: form.title,
                            value: form.id
                        }))}
                        onChange={(e) => onValueChangeHandler('form_id', e.target.value as number)}
                        placeholder="Select Forms"
                        error={false}
                        value={selectedAutomation?.form_id || ''}
                        disabled={loaders.isUpdating}
                    />
                </Box>
            </Box>
        </Box>
            {/* <Box display="flex" alignItems="center">
                <Typography variant="body1" color="textDisabled" minWidth="20%">Choose who can view automations</Typography>
                <Box display="flex" gap="20px" width="100%" boxSizing="border-box">
                    <Box boxSizing="border-box" minWidth="200px">
                        <Autocomplete
                            multiple
                            options={customers.map((cus) => ({
                                label: cus.name || `${cus.first_name} ${cus.last_name}`,
                                value: cus.id
                            }))}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            value={selectedNames}
                            onChange={(event, newValue) => setSelectedNames(newValue)}
                            renderTags={(value, getTagProps) => value.map((option, index) => (
                                <Chip
                                    label={option.label}
                                    {...getTagProps({ index })}
                                    key={option.value}
                                />
                            ))
                            }
                            renderInput={(params) => (
                                <TextField {...params} variant="outlined" placeholder="Select Name" />
                            )}
                            fullWidth
                        />
                    </Box>
                </Box>
            </Box> */}
            </Box>}
        <LabelWrapper label="Workflow Logs" />
        <Box height="50vh" width="100%">
            <DataGrid
                rows={rows as WorkFlowLogOject[]}
                loading={activityLoaders.isLoading}
                columns={columns}
                pagination
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 20
                        }
                    }
                }}
                sx={{
                    '& .MuiDataGrid-row--borderBottom': {
                        backgroundColor: `${brand[50]} !important`
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 'bold'
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        fontWeight: 'bold'
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: '14px'
                    },
                    'width': '100%',
                    'overflowX': 'hidden'
                }}
            />
        </Box>
        <Box px={2} borderRadius={1} mt={1} display="none" justifyContent="space-between" alignItems="center" py="0.1rem" bgcolor={orange[100]} color={orange[400]} height="max-content">
            <Typography variant="body1" fontWeight="500">Note: Automation for each deal will stop automatically once communication is established with your client.</Typography>
            <IconButton color="warning" size="small"><Close color="warning" /></IconButton>
        </Box>
    </Box>;
};

export default AutomationSettingsComponent;